__turbopack_context__.v({
  "className": "eb_garamond_7c37486f-module__JUFI0W__className",
  "variable": "eb_garamond_7c37486f-module__JUFI0W__variable",
});
